var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVietlott(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3578_16003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 13.5817 13.5817 10 18 10H34C38.4183 10 42 13.5817 42 18V42H18C13.5817 42 10 38.4183 10 34V18Z",
    fill: "url(#paint0_linear_3578_16003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 13.5817 13.5817 10 18 10H34C38.4183 10 42 13.5817 42 18V42H18C13.5817 42 10 38.4183 10 34V18Z",
    fill: "url(#paint1_linear_3578_16003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 13.5817 13.5817 10 18 10H34C38.4183 10 42 13.5817 42 18V42H18C13.5817 42 10 38.4183 10 34V18Z",
    fill: "url(#paint2_linear_3578_16003)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0259 20.3202C24.1964 20.9654 25.4379 21.2443 26.7503 21.2269C26.8862 21.2269 27.0222 21.225 27.1582 21.223C27.4301 21.2191 27.702 21.2153 27.974 21.2269C28.2755 21.2443 28.4351 21.1571 28.5237 20.8433L28.5451 20.7613C28.7332 20.0378 28.9249 19.3003 29.2154 18.6115C29.5878 17.7048 29.0913 17.2515 28.3109 17.0946C27.105 16.833 25.899 16.8156 24.6753 16.9202C23.3629 17.0422 22.1747 17.5479 21.0219 18.1233C20.7559 18.2628 20.4721 18.472 20.4899 18.8207C20.5057 19.117 20.7486 19.232 20.9773 19.3403L20.9774 19.3403C21.0044 19.3531 21.0312 19.3658 21.0574 19.3787C21.2761 19.4833 21.4968 19.584 21.7175 19.6848C22.1589 19.8863 22.6003 20.0877 23.0259 20.3202ZM24.8326 22.0622C25.3464 22.0451 25.8236 22.1984 26.2457 22.4537C26.4548 22.5831 26.6607 22.7185 26.8661 22.8536L26.8661 22.8536C27.1473 23.0385 27.4275 23.2228 27.7138 23.3901C27.9524 23.5263 27.9891 23.6625 27.8973 23.9008C27.7964 24.1477 27.7092 24.3945 27.6221 24.6413L27.6221 24.6414C27.5349 24.8883 27.4477 25.1351 27.3468 25.382C27.0899 26.0289 26.6861 26.5737 26.0805 26.9993C24.7455 27.9336 23.418 28.8748 22.0932 29.8141L22.0929 29.8143L22.0924 29.8146L22.0924 29.8147C21.3413 30.3472 20.5911 30.8791 19.8409 31.4087C18.9967 32.0046 18.3911 31.9024 17.8406 31.0682C16.2256 28.6167 15.8219 26.0289 16.7945 23.2709C17.0147 22.624 17.3084 22.4197 18.0608 22.3856C19.1894 22.3346 20.318 22.2792 21.4466 22.2239L21.4466 22.2239L21.4467 22.2239H21.4467L21.4471 22.2239C22.5756 22.1686 23.7041 22.1132 24.8326 22.0622ZM26.1808 35.1234H25.8084C24.7798 35.0537 24.4605 34.6003 24.762 33.6413C24.9274 33.0977 25.0943 32.5526 25.2613 32.0068L25.2615 32.0063L25.2616 32.0059L25.2617 32.0057C25.6678 30.679 26.0751 29.3486 26.4646 28.0269C26.8193 26.8413 27.4222 25.8474 28.5218 25.1849C28.648 25.108 28.7722 25.0052 28.8951 24.9034L28.8951 24.9034C29.1347 24.705 29.3691 24.5108 29.6036 24.5223C29.8503 24.5344 30.0883 24.7489 30.3297 24.9664C30.4355 25.0616 30.5419 25.1575 30.65 25.2372L30.7794 25.3348L30.7795 25.3348C30.9613 25.4717 31.1337 25.6016 31.3062 25.7428C31.7673 26.1264 32.122 26.5623 32.3171 27.1377L32.3773 27.3099L32.3773 27.31C32.7299 28.3178 33.0868 29.3378 33.523 30.3111C33.8777 31.1305 33.7004 31.7408 33.0974 32.3336C31.6609 33.746 29.9406 34.5829 27.9543 34.9316C27.5641 35.0013 27.174 35.0401 26.7838 35.0788C26.5887 35.0982 26.3936 35.1176 26.1985 35.1408C26.1808 35.1408 26.1808 35.1408 26.1808 35.1234ZM35.7208 26.4954V26.4955C35.7267 26.8085 35.7332 27.1475 35.6325 27.469C35.4729 27.9746 35.2069 28.0792 34.7813 27.8002C34.1428 27.3643 33.5044 26.9284 32.8837 26.4751C32.4758 26.1787 32.2452 25.7253 32.0679 25.272C31.9295 24.9163 31.8103 24.5606 31.6912 24.2049C31.6117 23.9678 31.5323 23.7307 31.4471 23.4935C31.3762 23.3017 31.4471 23.1971 31.6067 23.0751C31.9259 22.8572 32.245 22.6349 32.5642 22.4127L32.5644 22.4125C32.8837 22.1902 33.2029 21.9679 33.5221 21.7499C34.1074 21.3489 34.5153 21.4535 34.8522 22.0638C35.3843 23.0402 35.7212 24.5746 35.7212 26.1264C35.7161 26.243 35.7184 26.367 35.7208 26.4954ZM31.7118 21.223C31.8419 21.2249 31.9719 21.2268 32.102 21.2268C32.5099 21.2268 32.9178 21.2268 33.3079 21.2443C33.574 21.2443 33.8045 21.1571 33.9287 20.913C34.0291 20.699 33.8766 20.5316 33.7399 20.3815C33.7318 20.3726 33.7238 20.3638 33.7158 20.355C33.0951 19.675 32.4389 19.0648 31.6941 18.5243C31.3394 18.2627 30.9847 18.0012 30.559 17.8966C29.9738 17.7396 29.6368 18.0535 29.8142 18.6289C29.921 18.9843 30.0354 19.3398 30.1504 19.697C30.2836 20.1107 30.4176 20.5268 30.5413 20.9479C30.6123 21.1571 30.7009 21.2268 30.9315 21.2268C31.1916 21.2152 31.4517 21.2191 31.7118 21.223Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3578_16003",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.429333 0 0 0 0 0.108333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3578_16003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3578_16003",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3578_16003",
    x1: 28.6531,
    y1: 41.6814,
    x2: 28.3401,
    y2: 8.82096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3578_16003",
    x1: 28.2593,
    y1: 42,
    x2: 28.0619,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3578_16003",
    x1: 26,
    y1: 10,
    x2: 26,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA1515"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietlott);
export default __webpack_public_path__ + "static/media/vietlott.3b5bb63410f2370118c4ac44d09b042c.svg";
export { ForwardRef as ReactComponent };